import { useAuthStore } from '@/stores/authStore';

interface HeaderProps {
  title:    string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export const Header = ({ title, subtitle, actions }: HeaderProps) => {
  const filiale = useAuthStore((s) => s.filiale);
  return (
    <header className="sticky top-0 z-10 bg-white">
      <div className="flex items-center gap-4 px-6 py-3.5">
        <div className="min-w-0 flex-1">
          <h1 className="truncate text-lg font-semibold text-gray-900">{title}</h1>
          {subtitle && <p className="truncate text-xs text-gray-500">{subtitle}</p>}
        </div>
        {filiale && (
          <span
            className="hidden text-[11px] font-semibold uppercase tracking-wider md:inline rounded-full px-3.5 py-1.5 shadow-sm"
            style={{
              background: `linear-gradient(135deg, ${filiale.colorPrimary}, ${filiale.colorSecondary})`,
              color:      'white',
            }}
          >
            {filiale.metierLabel}
          </span>
        )}
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {/* Bordure brand 2px */}
      <div className="h-[3px] bg-gradient-to-r from-[var(--color-brand-primary)] via-[var(--color-brand-secondary)] to-[var(--color-brand-accent)]" />
    </header>
  );
};
